import script from "./ReviewDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReviewDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ReviewDetails.vue?vue&type=style&index=0&id=9dc34c62&lang=scss&scoped=true"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc34c62"]])

export default __exports__